import { authCall } from '.'
import { ResponseStatus } from '../interfaces/common'
import { estateVerification } from './endpoints'

/**
 * The verification payload supports both KYC and KYB fields. Keeping this
 * extensible also allows document URLs or FormData to be passed as the API
 * contract evolves.
 */
export interface VerificationDocument {
  code: string
  label: string
  url: string
  mimeType: string
  size: number
}

export interface EstateVerificationPayload {
  verificationType?: 'kyc' | 'kyb' | 'KYC' | 'KYB'
  details?: Record<string, unknown>
  documents?: VerificationDocument[]
  [key: string]: unknown
}

export interface EstateVerificationDetails extends EstateVerificationPayload {
  id?: string
  estateId?: string
  status?: string
}

export type EstateVerificationData = EstateVerificationPayload | FormData

const EstateVerificationService = {
  submitVerification: (
    estateId: string,
    data: EstateVerificationData
  ) => {
    return authCall<ResponseStatus<EstateVerificationDetails>>({
      url: estateVerification(estateId),
      data,
      method: 'post',
    })
  },

  updateVerification: (
    estateId: string,
    data: EstateVerificationData
  ) => {
    return authCall<ResponseStatus<EstateVerificationDetails>>({
      url: estateVerification(estateId),
      data,
      method: 'patch',
    })
  },

  getVerification: (estateId: string) => {
    return authCall<ResponseStatus<EstateVerificationDetails>>({
      url: estateVerification(estateId),
      method: 'get',
    })
  },
}

export default EstateVerificationService
